export interface DragOptions {
  start?: (e: MouseEvent) => void;
  drag?: (e: MouseEvent) => void;
  end?: (e: MouseEvent) => void;
}

let isDragging = false;

export function draggable(el: HTMLElement, options: DragOptions) {
  const moveFn = function(event: MouseEvent) {
    if (options.drag) {
      options.drag(event);
    }
  };

  const upFn = function(event: MouseEvent) {
    document.removeEventListener("mousemove", moveFn);
    document.removeEventListener("mouseup", upFn);
    document.onselectstart = null;
    document.ondragstart = null;
    isDragging = false;
    if (options.end) {
      options.end(event);
    }
  };

  el.addEventListener("mousedown", e => {
    if (isDragging) return;
    document.onselectstart = () => false;
    document.ondragstart = () => false;

    document.addEventListener("mousemove", moveFn);
    document.addEventListener("mouseup", upFn);
    isDragging = true;
    if (options.start) {
      options.start(e);
    }
  });
}
